import React from "react";
import { View, Text, Pressable, StyleSheet, Dimensions } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { REGISTRY_STARTER_TEMPLATES } from "../../../constants/RegistryStarterTemplates";
import { SPOTLIGHT_TARGETS, spotlightTarget } from "../../../Widgets/SpotlightTutorial/spotlightTargets";
import RegistrySetupModal, { REGISTRY_SETUP_COLORS } from "./RegistrySetupModal";

const isMobile = Dimensions.get("window").width < 768;

const TEMPLATE_ICONS = {
	"dorm-room": "bed-outline",
	"first-apartment": "home-outline",
};

const BUILD_OWN_CHOICE = {
	title: "Build My Own",
	description: "Browse the full catalog",
	actionLabel: "Start From Scratch",
	icon: "search-outline",
};

const ChoiceCard = ({ icon, title, description, actionLabel, onPress }) => (
	<Pressable style={styles.choiceCard} onPress={onPress} accessibilityRole="button" accessibilityLabel={`${title}. ${description}`}>
		<Ionicons name={icon} size={40} color={REGISTRY_SETUP_COLORS.green} />
		<Text style={styles.choiceTitle}>{title}</Text>
		<Text style={styles.choiceDescription}>{description}</Text>
		<View style={styles.choiceAction}>
			<Text style={styles.choiceActionLabel}>{actionLabel}</Text>
		</View>
	</Pressable>
);

const RegistryStarterChoices = ({ onSelectTemplate, onBuildOwn, onClose }) => (
	<RegistrySetupModal title="Create Your Registry" subtitle="Start with a ready-made list, or build your own from scratch." onClose={onClose}>
		<View style={styles.choices} {...spotlightTarget(SPOTLIGHT_TARGETS.REGISTRY_STARTER_CHOICES)}>
			{REGISTRY_STARTER_TEMPLATES.map((template) => (
				<ChoiceCard
					key={template.id}
					icon={TEMPLATE_ICONS[template.id] || "gift-outline"}
					title={template.title}
					description={template.description}
					actionLabel="Start With This"
					onPress={() => onSelectTemplate(template)}
				/>
			))}
			<ChoiceCard {...BUILD_OWN_CHOICE} onPress={onBuildOwn} />
		</View>
	</RegistrySetupModal>
);

const styles = StyleSheet.create({
	choices: {
		flexDirection: isMobile ? "column" : "row",
		gap: 16,
		paddingBottom: 16,
	},
	choiceCard: {
		flex: 1,
		alignItems: "center",
		padding: 20,
		gap: 8,
		borderRadius: 16,
		borderWidth: 1,
		borderColor: "rgba(76, 149, 108, 0.35)",
		backgroundColor: "rgba(255, 255, 255, 0.7)",
	},
	choiceTitle: {
		fontFamily: "Orpheus Pro",
		fontSize: 18,
		fontWeight: "600",
		color: REGISTRY_SETUP_COLORS.darkGreen,
		textAlign: "center",
	},
	choiceDescription: {
		fontSize: 14,
		lineHeight: 20,
		color: REGISTRY_SETUP_COLORS.mutedText,
		textAlign: "center",
	},
	choiceAction: {
		marginTop: 8,
		paddingVertical: 10,
		paddingHorizontal: 18,
		borderRadius: 20,
		backgroundColor: REGISTRY_SETUP_COLORS.green,
	},
	choiceActionLabel: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "600",
	},
});

export default RegistryStarterChoices;
